import { Filter } from "./filter";
import { Id } from "./id";

type OrganizationalUnitsFilter = Filter & {
  parentUuid?: Id;
  page: number;
  size: number;
};

const organizationalUnitsFilter: OrganizationalUnitsFilter = {
  page: 0,
  size: 20,
};

export type { OrganizationalUnitsFilter };

export { organizationalUnitsFilter };
